<template>
  <div>
      <router-view :key="componentKey" />
    <footer-bottom></footer-bottom>
  </div>
</template>

<script>
import FooterBottom from "@/components/Footer";
export default {
  name: "BasicLayout",
  components: {
    FooterBottom
  },
  data(){
    return{
      componentKey:0
    }
  },
   methods: {
      getData(){
        this.componentKey += 1
      }
   }
};
</script>

<style>
</style>